import { Injectable } from '@angular/core';
import { from, Subject, Subscription } from 'rxjs';

/**
 * Globalny mechanizm eventow aplikacyjnych. Mozna go wykorzystac w miejsce $rootScop.$on, $rootScop.$broadcast, $rootScop.$emit.
 *
 * @export
 * @class EventsService
 */
@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private listeners: { [x: string]: Function[] } = {};
  private eventsSubject = new Subject();
  private events;
  private subscription: Subscription;
  constructor() {
    this.events = from(this.eventsSubject);
    this.createSubscription();
  }

  private createSubscription() {
    this.subscription = this.events.subscribe(
      ({ name, args }) => {
        if (this.listeners[name]) {
          for (const listener of this.listeners[name]) {
            listener(...args);
          }
        }
      });
  }

  on(name: string, listener: Function): () => void {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }
    this.listeners[name].push(listener);
    return () => {
      this.off(name, listener);
    }
  }

  off(name: string, listener: Function) {
    this.listeners[name] = this.listeners[name].filter(x => x !== listener);
  }

  emit(name: string, ...args: any[]) {
    if (this.subscription.closed) {
      this.createSubscription();
    }
    this.eventsSubject.next({
      name,
      args
    });
  }

}
